import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const TermsPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F9F9F8]">
      <header className="bg-white border-b border-[#E4E4E7]">
        <div className="max-w-4xl mx-auto px-6 py-4 flex items-center gap-4">
          <Button
            variant="ghost"
            size="icon"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="h-5 w-5" />
          </Button>
          <h1 className="text-2xl font-bold tracking-tight">Termos de Uso</h1>
        </div>
      </header>

      <main className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-white border border-[#E4E4E7] rounded-lg p-8 space-y-6">
          <p className="text-sm text-gray-500">Última atualização: 30 de março de 2026</p>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">1. Sobre a Plataforma</h2>
            <p className="text-gray-600 leading-relaxed">
              O <strong>Quero Publicar</strong> é uma plataforma gratuita que conecta pesquisadores 
              a chamadas para publicações em revistas científicas, congressos e livros acadêmicos no Brasil.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">2. Cadastro e Conta</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>O cadastro é feito exclusivamente via Google.</li>
              <li>Você é responsável por manter seus dados atualizados.</li>
              <li>Sua conta é pessoal e intransferível.</li>
              <li>Podemos suspender contas que violem estes termos.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">3. Uso da Plataforma</h2>
            <p className="text-gray-600 leading-relaxed">Ao usar o Quero Publicar, você concorda em:</p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Usar a plataforma apenas para fins acadêmicos e de pesquisa.</li>
              <li>Não enviar informações falsas ou enganosas.</li>
              <li>Não tentar acessar áreas restritas do sistema.</li>
              <li>Respeitar os direitos autorais das revistas e publicações.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">4. Conteúdo e Chamadas</h2>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>As chamadas são coletadas de fontes públicas e enviadas por usuários.</li>
              <li>Não garantimos a precisão ou atualização de todas as informações.</li>
              <li>Sempre verifique as informações diretamente no site oficial da revista.</li>
              <li>Sugestões de chamadas passam por revisão antes de serem publicadas.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">5. Propriedade Intelectual</h2>
            <p className="text-gray-600 leading-relaxed">
              O design, código e funcionalidades do Quero Publicar são de propriedade da plataforma. 
              As informações das chamadas pertencem às respectivas revistas e eventos.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">6. Limitação de Responsabilidade</h2>
            <p className="text-gray-600 leading-relaxed">
              O Quero Publicar é um serviço de divulgação. Não nos responsabilizamos por:
            </p>
            <ul className="list-disc list-inside text-gray-600 space-y-2">
              <li>Decisões editoriais das revistas.</li>
              <li>Alterações de prazos ou cancelamentos de chamadas.</li>
              <li>Perdas decorrentes do uso das informações da plataforma.</li>
            </ul>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">7. Alterações nos Termos</h2>
            <p className="text-gray-600 leading-relaxed">
              Podemos atualizar estes termos a qualquer momento. Alterações significativas 
              serão comunicadas por email ou aviso na plataforma.
            </p>
          </section>

          <section className="space-y-3">
            <h2 className="text-xl font-semibold text-gray-900">8. Contato</h2>
            <p className="text-gray-600 leading-relaxed">
              Dúvidas? Entre em contato pelo email: <a href="mailto:quero.publicar@queropublicar.org" className="text-blue-600 hover:underline">quero.publicar@queropublicar.org</a>
            </p>
          </section>

          <div className="pt-6 border-t border-gray-200">
            <p className="text-sm text-gray-500 text-center">
              Ao usar o Quero Publicar, você concorda com estes Termos de Uso.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
};

export default TermsPage;
